// extracted by mini-css-extract-plugin
export default {"explore_card_wrapper":"p5","explore_card":"q5","img":"r5","name":"s5","creds":"t5","bio":"u5"};
    if(module.hot) {
      // 1738064244022
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  